export const columnChooser = {
  Attributes: _TL_('Attributes'),
  ColumnChooser_Add: _TL_('Add'),
  ColumnChooser_AddAllInList: _TL_('Add all columns'),
  ColumnChooser_AddColumn: _TL_('Add Column {{columnName}}'),
  ColumnChooser_Added: _TL_('Added'),
  ColumnChooser_Apply: _TL_('Apply'),
  ColumnChooser_ApplySavedColumns: _TL_('Apply'),
  ColumnChooser_AvailableColumnsHeader: _TL_('Available columns'),
  ColumnChooser_Cancel: _TL_('Cancel'),
  ColumnChooser_CancelReplace: _TL_('Cancel'),
  ColumnChooser_ConfirmCancel: _TL_('Cancel'),
  ColumnChooser_ConfirmRemove: _TL_('Remove'),
  ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
  ColumnChooser_CustomColumnsCategory: _TL_('Custom Columns'),
  ColumnChooser_Disabled: _TL_('Add'),
  ColumnChooser_Entry: _TL_('Columns'),
  ColumnChooser_Header: _TL_('Modify columns'),
  ColumnChooser_IfReplaceColumnName: _TL_('Do you want to replace it?'),
  ColumnChooser_ModifyColumns: _TL_('Modify columns'),
  ColumnChooser_PromptBeforeRemove: _TL_('Are you sure you want to remove saved item: {0}'),
  ColumnChooser_Remove: _TL_('Remove'),
  ColumnChooser_RemoveAllInList: _TL_('Remove all columns'),
  ColumnChooser_RemoveAllSelected: _TL_('Remove all selected columns'),
  ColumnChooser_NoSearchResult: _TL_('No results found'),
  ColumnChooser_RemoveColumn: _TL_('Remove Column {{columnName}}'),
  ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
  ColumnChooser_SaveColumnDescription: _TL_('Save this set of columns'),
  ColumnChooser_Search_Column: _TL_('Search column'),
  ColumnChooser_SelectedColumnsHeader: _TL_('Selected columns (drag and drop to reorder)'),
  ColumnChooser_SelectedColumnsHeader_BottomHalf: _TL_('Selected columns'),
  ColumnChooser_SelectedColumnsHeader_TopHalf: _TL_('Selected rows'),
  ColumnChooser_SubHeader: _TL_(''),
  ColumnChooser_ConfirmReplace: _TL_('Replace'),
  ColumnsMenu_Custom: _TL_('Custom'),
  CustomColumn_DoesNotExist: _TL_('This custom column does not exists.'),
  ColumnName_Clicks: _TL_('Clicks'),
  ColumnName_Impressions: _TL_('Impr.'),
  ColumnName_Spend: _TL_('Spend'),
  ColumnChooser_LiftColumn: _TL_('You have lifted the {{columnName}} column in position {{positionFrom}}.'),
  ColumnChooser_MoveColumn: _TL_('You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
  ColumnChooser_DropColumn: _TL_('You have dropped the {{columnName}} column. You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
  ColumnChooser_RemovedColumns: _TL_('You have removed the {{columnNames}} columns.'),
  ColumnChooser_RemovedColumn: _TL_('You have removed the {{columnNames}} column.'),
  ColumnChooser_AddedColumns: _TL_('You have added the {{columnNames}} columns.'),
  ColumnChooser_AddedColumn: _TL_('You have added the {{columnNames}} column.'),
};
